import * as Sentry from '@sentry/react';
import { Suspense, memo, useCallback } from 'react';
import { Route, Routes } from 'react-router-dom';

import { AppRoutesProps } from 'shared/types/router';

import { RequireAuth } from './RequireAuth';

import { routeConfig } from '../config/routeConfig';

type RenderWithWrapperParams = [string, AppRoutesProps];

const SentryRoutes = Sentry.wrapReactRouterRouting(Routes);

const AppRouter = () => {
  const renderWithWrapper = useCallback(
    ([routeName, route]: RenderWithWrapperParams) => {
      let element = <Suspense fallback={<div />}>{route.element}</Suspense>;

      if (route.authOnly) {
        element = <RequireAuth>{element}</RequireAuth>;
      }

      if (route?.index === true) {
        return (
          <Route key={routeName} index={true as const} element={element} />
        );
      }

      return (
        <Route key={routeName} path={route?.path} element={element}>
          {route.nested
            ? Object.entries(route.nested).map(renderWithWrapper)
            : null}
        </Route>
      );
    },
    [],
  );

  return (
    <SentryRoutes>
      {Object.entries(routeConfig).map(renderWithWrapper)}
    </SentryRoutes>
  );
};

export default memo(AppRouter);
